<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon :size="iconSize">{{activatorIcon ? activatorIcon:'mdi-playlist-edit'}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>{{topic ? 'Edit Topic':'New Topic'}}</v-card-title>
        <v-card-text>
          <v-text-field label="Topic Name" v-model="name"></v-text-field>
          <v-textarea :auto-grow="true" row-height="5" label="Description" v-model="description"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="isAppLoading" @click="saveOrUpdateTopic">{{topic ? 'Update':'Save'}}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    activatorIcon: {
      type: String,
      required: false
    },
    topic: {
      type: Object,
      required: false
    },
    courseId: {
      type: Number,
      required: true
    },
    iconSize: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      name: "",
      description: ""
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["isAppLoading"])
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage"]),
    saveOrUpdateTopic() {
      const params = {
        courseId: this.courseId
      };

      //Existing topic, do update
      if (this.topic && this.topic.id) {
        const data = {
          id: this.topic.id,
          name: this.name,
          description: this.description
        };
        this.$axios
          .post("/course/topic/editTopic", data, { params })
          .then(resp => {
            const updatedTopic = resp.data.data;
            this.$emit("updated", updatedTopic);
            this.dialog = false;
          })
          .catch(error => {
            this.addErrorMessage(error.message);
          });
      } else {
        const data = {
          name: this.name
        };
        //Enter new topic
        this.$axios
          .post("/course/topic/addTopic", data, { params })
          .then(resp => {
            const savedTopic = resp.data.data;
            this.$emit("saved", savedTopic);
            this.dialog = false;
          })
          .catch(error => {
            this.addErrorMessage(error.message);
          });
      }
    }
  },
  mounted() {
    if (this.topic) {
      this.name = this.topic.name;
      this.description = this.topic.description;
    }
  }
};
</script>

<style>
</style>